import { Observable } from '@reactivex/rxjs';

export function fromEventSource(url, opts) {
    return new EventSourceObservable(url, opts);
}

class EventSourceObservable extends Observable {
    constructor(url, opts) {
        super();
        this._url = url;
        this.opts = opts;
    }
    subscribe(sink) {
        const next = sink.next.bind(sink);
        const error = sink.error.bind(sink);
        const complete = sink.complete.bind(sink);
        const source = new EventSource(this._url, this.opts);
        source.onerror = error;
        source.onopen = source.onmessage = next;
        source.addEventListener('end', complete);
        source.addEventListener('error', error);
        source.addEventListener('close', complete);
        source.addEventListener('finish', complete);
        source.addEventListener('complete', complete);
        return () => {
            source.onopen = null;
            source.onerror = null;
            source.onmessage = null;
            source.removeEventListener('error', error);
            source.removeEventListener('message', next);
            source.removeEventListener('end', complete);
            source.removeEventListener('close', complete);
            source.removeEventListener('finish', complete);
            source.removeEventListener('complete', complete);
            source.close();
        };
    }
}
